var map = {
	"./result1.png": 9295,
	"./result10.png": 5256,
	"./result11.png": 4901,
	"./result12.png": 1868,
	"./result12_1.png": 8686,
	"./result13.png": 1031,
	"./result1_1.png": 2397,
	"./result1_2.png": 7822,
	"./result2.png": 7476,
	"./result3.png": 5483,
	"./result4.png": 8914,
	"./result5.png": 837,
	"./result6.png": 1602,
	"./result7.png": 3909,
	"./result8.png": 1856,
	"./result9.png": 2573
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6623;